export enum SidebarVisibility {
  On = 1,
  Off = 2,
}
